import { Checkbox, NumberFormatter } from '@mantine/core';
import { useUnit } from 'effector-react';
import { DASHBOARD_METRIC_KEYS } from '../../config';
import { getDashboardMetricName } from '../../lib';
import { dashboardPageModel } from '../../model';
import cls from './dashboard-sidebar.module.scss';

const fallbackMetrics = DASHBOARD_METRIC_KEYS.map((key) => ({ key }));

export const DashboardSidebar = () => {
	const [dashboardSummary, summaryFailed, selectedMetrics, setSelectedMetrics] = useUnit([
		dashboardPageModel.$summary,
		dashboardPageModel.getDashboardSummaryQuery.$failed,
		dashboardPageModel.$selectedMetrics,
		dashboardPageModel.setSelectedMetrics,
	]);

	const summary = summaryFailed ? null : dashboardSummary;
	const metrics = summary?.metrics ?? fallbackMetrics;

	const dateRange =
		summary?.from && summary.to
			? `${summary.from.slice(0, 10)} - ${summary.to.slice(0, 10)}`
			: null;

	const toggleMetric = (key: string) => {
		setSelectedMetrics(
			selectedMetrics.includes(key)
				? selectedMetrics.filter((metric) => metric !== key)
				: [...selectedMetrics, key],
		);
	};

	return (
		<div className={cls.dashboardSidebar}>
			{metrics.map((item) => {
				const checked = selectedMetrics.includes(item.key);
				const name = getDashboardMetricName(item.key);

				return (
					<div
						key={item.key}
						className={cls.dashboardSidebarCard}
						data-interactive={summary ? true : undefined}
						data-checked={(summary && checked) || undefined}
						onClick={summary ? () => toggleMetric(item.key) : undefined}
					>
						<div className={cls.dashboardSidebarCardContent}>
							<div className={cls.dashboardSidebarCardTitle}>
								<span>{name}</span>
								{summary && (
									<Checkbox
										variant='primary'
										checked={checked}
										aria-label={name}
										className={cls.dashboardSidebarCardCheckbox}
										onClick={(event) => event.stopPropagation()}
										onChange={() => toggleMetric(item.key)}
									/>
								)}
							</div>
							{summary && dateRange && (
								<div className={cls.dashboardSidebarCardData}>
									<span>{dateRange}</span>
									<span>{summary.currency}</span>
								</div>
							)}
						</div>
						{summary && 'total' in item && (
							<div className={cls.dashboardSidebarCardTotal}>
								<NumberFormatter value={item.total} />
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};
